// Lista blanca de usuarios autorizados para el Dashboard JMA AFAC.
//
// Aunque cualquier cuenta del tenant JMA Seguridad podría completar el
// flujo OAuth 2.0 contra la App Registration, sólo los correos listados
// aquí pueden usar la aplicación. La comparación es case-insensitive y
// tolerante a espacios.
//
// Mantener este archivo es responsabilidad de la Dirección de
// Ciberseguridad. En v2.0 se evaluará reemplazar este mecanismo por
// App Roles en Microsoft Entra ID (permisos granulares por rol).

export const ALLOWED_USERS = [
  'flazzarini@jmacybersec.com',
  'jalvarez@jmaseguridad.com'
]

/**
 * Determina si un correo electrónico está autorizado.
 * @param {string|null|undefined} email
 * @returns {boolean}
 */
export function isUserAllowed(email) {
  if (!email) return false
  const normalized = String(email).trim().toLowerCase()
  return ALLOWED_USERS.some((u) => u.toLowerCase() === normalized)
}
